/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CustomizeIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="CustomizeIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.99994 3.29289C7.18748 3.10536 7.44183 3 7.70705 3H10.4999C10.7022 3 10.8845 3.12182 10.9619 3.30866C11.0393 3.4955 10.9965 3.71055 10.8535 3.85355L8.99994 5.70711V7H10.2928L12.1464 5.14645C12.2894 5.00345 12.5044 4.96067 12.6913 5.03806C12.8781 5.11545 12.9999 5.29777 12.9999 5.5V8.29289C12.9999 8.55811 12.8946 8.81246 12.707 9L10.9999 10.7071C10.8124 10.8946 10.558 11 10.2928 11H7.70705L4.85349 13.8536C4.65823 14.0488 4.34165 14.0488 4.14639 13.8536L2.14639 11.8536C1.95112 11.6583 1.95112 11.3417 2.14639 11.1464L4.99994 8.29289V5.70711C4.99994 5.44189 5.1053 5.18754 5.29283 5L6.99994 3.29289ZM9.29283 4H7.70705L5.99994 5.70711L5.99994 8.29289C5.99994 8.55811 5.89458 8.81246 5.70705 9L3.20705 11.5L4.49994 12.7929L6.99994 10.2929C7.18748 10.1054 7.44183 10 7.70705 10H10.2928L11.9999 8.29289V6.70711L10.8535 7.85355C10.7597 7.94732 10.6325 8 10.4999 8H8.49994C8.2238 8 7.99994 7.77614 7.99994 7.5V5.5C7.99994 5.36739 8.05262 5.24021 8.14639 5.14645L9.29283 4Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

CustomizeIcon.tags = [
  'wrench',
  'tool',
  'fix',
  'settings',
  'repair',
  'adjust',
  'maintenance',
];

CustomizeIcon.category = 'General Icons';

CustomizeIcon.iconSize = 16;
